import { CategorizationTagColor, StatusColor, type StatusColorType } from "@quortex/front-common"

// Copied from https://validators.readthedocs.io/en/latest/_modules/validators/domain.html#domain
export const domainPattern =
  /^(([a-zA-Z]{1})|([a-zA-Z]{1}[a-zA-Z]{1})|([a-zA-Z]{1}[0-9]{1})|([0-9]{1}[a-zA-Z]{1})|([a-zA-Z0-9][-_.a-zA-Z0-9]{0,61}[a-zA-Z0-9]))\.([a-zA-Z]{2,13}|[a-zA-Z0-9-]{2,30}.[a-zA-Z]{2,3})$/

export const builtInTag = {
  color: CategorizationTagColor.GREY,
  label: "Built-in"
}

export type SwitchStatus = api.ott.PoolContentSteering["switchStatus"]

export const switchStatusToLabel: Record<SwitchStatus, string> = {
  in_sync: "Syncing",
  ready: "Ready",
  sync: "In sync"
}

export const switchStatusToColor: Record<SwitchStatus, StatusColorType> = {
  in_sync: StatusColor.CONFIGURING,
  ready: StatusColor.INFO,
  sync: StatusColor.SUCCESS
}
